import React from 'react';
import Users from '../components/Users';

export default function AllUsers() {
  return (
    <div className="container is-max-desktop">
      <Users />
    </div>
  );
}
